<!-- Copyright (c) 2019-2025 Cigent Technology Inc. All Rights Reserved. -->

@switch (partnerId) {

    @case (lenovoPartner) {
        <div mat-dialog-title>
            <h2 mat-dialog-title>ThinkShield Data Defense</h2>
            <div>Powered by Cigent</div>
        </div>
        <mat-dialog-content>
            <div class="copyright-wrapper">
                <span>
                  <p>
                    {{ 'about.lenovo-terms-fragment' | translate }}
                      <a href="{{LenovoUserAgreementURL}}" target="_blank" rel="noopener noreferrer">
                      {{ 'about.lenovo-license-agreement' | translate }}
                    </a>.
                  </p>
                </span>
            </div>
        </mat-dialog-content>
    }

    @case (cigentPartner) {
        <h2 mat-dialog-title>Cigent Data Defense</h2>
        <mat-dialog-content>
            <div class="copyright-wrapper cigent-wrapper">
                <p class="copyright">&copy; 2019-{{ thisYear }} {{ 'about.copyright' | translate }}</p>
                <p>
                    {{ 'about.terms-fragment' | translate }}
                    <a href="{{CigentUserAgreementURL}}" target="_blank" rel="noopener noreferrer">
                        {{ 'about.license-agreement' | translate }}
                    </a>.
                </p>
            </div>
        </mat-dialog-content>
    }

    @case (kanguruPartner) {
        <h2 mat-dialog-title>Cigent Data Defense</h2>
        <mat-dialog-content>
            <div class="copyright-wrapper cigent-wrapper">
                <p class="copyright">&copy; 2019-{{ thisYear }} {{ 'about.copyright' | translate }}</p>
                <p>
                    {{ 'about.terms-fragment' | translate }}
                    <a href="{{CigentUserAgreementURL}}" target="_blank" rel="noopener noreferrer">
                        {{ 'about.license-agreement' | translate }}
                    </a>.
                </p>
            </div>
        </mat-dialog-content>
    }

}

<mat-dialog-content>
    <mat-card appearance="raised" class="mat-elevation-z1">
        <mat-card-content class="scrollable-content">
            <div>{{ 'about.console-version' | translate: {version: data.consoleVersion} }}</div>
            <div>{{ 'about.api-version' | translate: {version: data.restApiVersion} }}</div>

            @if (data?.winAgentVersions) {
                @for (winAgentVersion of data.winAgentVersions; track $index) {
                    <div>{{ 'about.win-agent-version' | translate: {version: winAgentVersion.version} }}</div>
                }
            }

            <div>{{ 'about.data-defense-version' | translate: {version: data.latestCigentVersion} }}</div>
            @if (data?.pbaVersions) {
                @for (pbaVersion of data.pbaVersions; track $index) {
                    <div>{{ 'about.pba-version' | translate: {version: pbaVersion.version} }}</div>
                }
            }

            @if (data?.winCliVersions) {
                @for (winCliVersion of data.winCliVersions; track $index) {
                    <div>{{ 'about.win-cli-version' | translate: {version: winCliVersion.version} }}</div>
                }
            }

            @if (data?.ubuntuCliVersions) {
                @for (ubuntuCliVersion of data.ubuntuCliVersions; track $index) {
                    <div>{{ 'about.ubuntu-cli-version' | translate: {version: ubuntuCliVersion.version} }}</div>
                }
            }

            @if (data?.rhelCliVersions) {
                @for (rhelCliVersion of data.rhelCliVersions; track $index) {
                    <div>{{ 'about.rhel-cli-version' | translate: {version: rhelCliVersion.version} }}</div>
                }
            }

            @if (data?.winFdeVersions) {
                @for (winFdeVersions of data.winFdeVersions; track $index) {
                    <div>{{ 'about.win-fde-version' | translate: {version: winFdeVersions.version} }}</div>
                }
            }

            @if (data?.ubuntuFdeVersions) {
                @for (ubuntuFdeVersions of data.ubuntuFdeVersions; track $index) {
                    <div>{{ 'about.ubuntu-fde-version' | translate: {version: ubuntuFdeVersions.version} }}</div>
                }
            }

            @if (data?.rhelFdeVersions) {
                @for (rhelFdeVersions of data.rhelFdeVersions; track $index) {
                    <div>{{ 'about.rhel-fde-version' | translate: {version: rhelFdeVersions.version} }}</div>
                }
            }

            @if (data?.ubuntuAgentVersions) {
                @for (ubuntuAgentVersion of data.ubuntuAgentVersions; track $index) {
                    <div>{{ 'about.ubuntu-agent-version' | translate: {version: ubuntuAgentVersion.version} }}</div>
                }
            }

            @if (data?.rhelAgentVersions) {
                @for (rhelAgentVersion of data.rhelAgentVersions; track $index) {
                    <div>{{ 'about.rhel-agent-version' | translate: {version: rhelAgentVersion.version} }}</div>
                }
            }
        </mat-card-content>
    </mat-card>
</mat-dialog-content>

<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="cancel()" class="close-btn">Close</button>
</div>
